<template>
	<!-- 整个页面的布局 -->
	<el-container class="container">
		<!-- 顶部导航栏 -->
		<el-header class="header">
			<div class="logo">
				<img src="@/assets/logo.png" alt="Logo" />
				<span>金顺机械设备</span>
			</div>
			<div class="header-right">
				<el-button type="danger" size="small" @click="LogoutHandle()">退出登录</el-button>
			</div>
		</el-header>

		<el-container>
			<!-- 侧边栏 -->
			<el-aside width="180px" class="aside">
				<SidebarMenu :activeMenu="activeMenu" />
			</el-aside>

			<!-- 主内容区 -->
			<el-main class="main">
				<transition name="zoom" mode="out-in">
					<router-view />
				</transition>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import router from '@/router'
	import SidebarMenu from '@/components/Sidebar/SidebarItem'
	import {
		mapActions
	} from 'vuex'

	export default {
		name: 'Layout',
		components: {
			SidebarMenu
		},
		data() {
			return {
				activeMenu: this.$route.path
			}
		},
		watch: {
			$route(to) {
				this.activeMenu = to.path
			}
		},
		methods: {
			...mapActions('user', ['logout']),
			LogoutHandle() {
				this.logout()
				this.$router.push('/login')
			}
		}
	}
</script>



<style lang="scss" scoped>
	.container {
		height: 100vh;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.header {
		background-color: #fbbd08;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
		height: 60px;
		flex-shrink: 0;
	}

	.logo {
		display: flex;
		align-items: center;
	}

	.logo img {
		height: 32px;
		margin-right: 10px;
	}

	/* 第二层 el-container */
	.el-container {
		flex: 1;
		display: flex;
		overflow: hidden;
		/* 禁止侧边栏滚动 */
	}

	.aside {
		background-color: #545c64;
		color: white;
		width: 180px;
		flex-shrink: 0;
		/* 去掉滚动 */
		overflow: hidden;
	}

	.main {
		background-color: #f5f5f5;
		padding: 20px;
		flex: 1;
		overflow-y: auto;
	}

	.zoom-enter-active,
	.zoom-leave-active {
		transition: all 0.3s ease;
	}

	.zoom-enter-from {
		opacity: 0;
		transform: scale(0.95);
	}

	.zoom-leave-to {
		opacity: 0;
		transform: scale(1.05);
	}
</style>